import {useState, useContext} from "react";
import {  Dialog } from "@material-ui/core"
import styles from '../css/CompetencePerformanceEvaluation.module.css'
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { closeEliminaEvaluationModel } from "../../../context/PerformanceEvaluationContext/Actions";
import { useMutation } from "@apollo/client";
import { DELETE_MODEL_EVALUATION, 
         GET_ALL_MODELS_EVALUATION } from "../../../Querys/querys";
import { ErrorAlert } from "../../../alerts/errorAlert";
import { SuccessfulAlert } from "../../../alerts/successAlerts";

const EliminaModelEvaluation = () =>{
    const {state, dispatch} = useContext(PerformanceEvaluationContext)
    const [activo, setactivo] = useState(false)
    const [deleteCompetence] = useMutation(DELETE_MODEL_EVALUATION, {
      refetchQueries: [{ query: GET_ALL_MODELS_EVALUATION }],
    });

    const handleChange = (e: any) =>{ 
      if(e.target.value === 'ELIMINAR'){
          setactivo(true)
      }else{
          setactivo(false)
      }
    }

    const handleDelete = async () =>{ 
        const deleteModel = await deleteCompetence({
        variables:{
            id: parseInt(state._id)
        }
      })
      const conteo = deleteModel.data.DELETE_MODEL_EVALUATION

      if (conteo > 0) {
        ErrorAlert({ text: 'No se puede eliminar un modelo de evaluación que ya está en una evaluación' })
      } else {
        SuccessfulAlert({ text: 'Modelo de evaluación eliminado correctamente'})
      }
      handleClose()
    }

    const handleClose = () =>{
        closeEliminaEvaluationModel('',false,dispatch)
        setactivo(false)
    }
    
    return(
      <Dialog aria-labelledby='costumized-dialog-title' open={state.eliminaModelEvaluation} fullWidth={false}  onClose={handleClose} maxWidth={"md"}>
        <div className={styles.em_container}>
          <div className={styles.contenedorCerrarModal}>
            <div 
              className={styles.cerrarModal}
              onClick={()=> handleClose()}>
            </div>
          </div>
          <div className={styles.contenedorPrincipal}>
            <div className={styles.iconoEliminar}>
            </div>
            <div className='em_titulo'>
              ¿Est&aacute;s seguro de que quieres eliminar el modelo de evaluación?
            </div>
            <div className={styles.em_mensajePrtincipal}>
                <span>Una vez eliminado no podr&aacute;s recuperar la informaci&oacute;n</span>
                <br />
                <span className={styles.em_textoPrincipal}>Escribe ELIMINAR para confirmar</span>
            </div>
            <div>
              <input 
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
        </div>
        <div className={styles.em_contenedorBotones}>
              <button 
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              {(activo === true ? 
                <button 
                  className={styles.em_botonConfirmarActivo}
                  onClick={()=> handleDelete()}
                  >
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              :
                <button className={styles.em_botonConfirmarInactivo}>
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              )}

            </div>
      </Dialog>
    )
}

export default EliminaModelEvaluation